import { Reveal, SectionHeading } from "./Reveal";
import { TESTIMONIALS } from "../data/content";

export default function Testimonials() {
  return (
    <section className="py-20 sm:py-28 lg:py-32" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <SectionHeading
          eyebrow="Testimonials"
          title="Words from the people she built with"
        />
        <div className="mt-12 sm:mt-16 grid md:grid-cols-2 gap-5 sm:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.author} delay={(i % 2) * 0.1} className="h-full">
              <figure className="h-full flex flex-col bg-white rounded-3xl border border-[#e5e5e7] p-8 sm:p-10 shadow-[0_4px_20px_rgba(0,0,0,0.03)]">
                <span className="font-serif-editorial italic text-6xl leading-none text-[#d4af37]">&ldquo;</span>
                <blockquote className="mt-2 flex-1 text-[15px] sm:text-base text-[#1d1d1f]/85 leading-relaxed">
                  {t.quote}
                </blockquote>
                <figcaption className="mt-7 pt-5 border-t border-[#e5e5e7]">
                  <p className="font-semibold text-[#1d1d1f]">{t.author}</p>
                  <p className="text-sm text-[#86868b]">{t.role} · {t.company}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
